import { dispatchStorageEvent } from './dispatch-storage-event'

export function setLocalStorageItem(key: string, value: string) {
  localStorage.setItem(key, value)
  dispatchStorageEvent(key, value)
}
